import React from 'react';
import {ModalContainer, Button} from '@xpertdox_js/xdcomponents';
import styles from './styles';

const ConfirmationModal = (props) => {
  // console.log('ConfirmationModal', props);

  return (
    <ModalContainer
      open={props.showModal}
      close={!props.showModal}
      showOverlay={props.showModal}
      style={styles.modal}
    >
      <div style={styles.content}>
        <p style={styles.question}>{props.question}</p>
        <div>
          <Button
            styles={styles.accept}
            hoverStyles={styles.acceptHov}
            className='internalButton'
            onClick={() => props.addConditions(props.nct)}
          >
            {props.acceptText}
          </Button>
          <Button
            styles={styles.cancel}
            hoverStyles={styles.cancelHov}
            className='internalButton'
            onClick={props.closeModal}
          >
            {props.declineText}
          </Button>
        </div>
      </div>
    </ModalContainer>
  )
}

export default ConfirmationModal;
